import ApiService from '../services/ApiService';

export default class CampaignRepository {
    constructor() {
        this.apiService = new ApiService();
    }

    convertSortString(sortString) {
        switch (sortString) {
            default:
                return sortString;
        }
    }

    createCampaign(medium, name) {
        return new Promise((resolve, reject) => {
            this.apiService
                .post('campaigns', {
                    medium: medium,
                    name: name
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    deleteCampaign(id) {
        return new Promise((resolve, reject) => {
            this.apiService
                .delete('campaigns/' + id)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    getCampaigns(sort = '') {
        return new Promise((resolve, reject) => {
            this.apiService
                .get('campaigns?sort=' + this.convertSortString(sort))
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    updateCampaign(id, medium, name) {
        return new Promise((resolve, reject) => {
            this.apiService
                .put('campaigns/' + id, {
                    name: name,
                    medium: medium
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}
